import { useTranslation } from "react-i18next";

import Button from "@/components/common/Button";

// Shown instead of an endless spinner when data the page needs failed to load.
export default function LoadFailed({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col flex-1 items-center justify-center gap-4 p-8 text-center">
      <p className="text-lg">{t("common.error.loading")}</p>
      <Button variant="outline" onClick={onRetry}>
        {t("common.tryAgain")}
      </Button>
    </div>
  );
}
